import { render, staticRenderFns } from "./masterSubSettlementModel.vue?vue&type=template&id=3906bff2&scoped=true&"
import script from "./masterSubSettlementModel.vue?vue&type=script&lang=js&"
export * from "./masterSubSettlementModel.vue?vue&type=script&lang=js&"
import style0 from "./masterSubSettlementModel.vue?vue&type=style&index=0&id=3906bff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906bff2",
  null
  
)

export default component.exports